module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "custom-class": "dialog-wrapper scroll-dialog",
      "title": _vm.dialogTitle,
      "close-on-click-modal": false,
      "modal-append-to-body": false
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('div', {
          staticClass: "flex-row-center"
        }, [_c('el-button', {
          on: {
            "click": function($event) {
              _vm.dialogVisible = false
            }
          }
        }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "primary"
          },
          on: {
            "click": _vm.clickEditDone
          }
        }, [_vm._v("确定")])], 1)]
      },
      proxy: true
    }]),
    model: {
      value: (_vm.dialogVisible),
      callback: function($$v) {
        _vm.dialogVisible = $$v
      },
      expression: "dialogVisible"
    }
  }, [_c('div', {
    staticClass: "item-title"
  }, [_vm._v("\n    屏蔽总开关 "), _c('span', {
    staticClass: "optional-tip"
  }, [_vm._v("（选填，可多选）")])]), _vm._v(" "), _c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "手机系统"
    }
  }, [_c('el-select', {
    staticClass: "campus-select",
    attrs: {
      "multiple": "",
      "placeholder": "可多选，已选不可重复"
    },
    model: {
      value: (_vm.systemBlock),
      callback: function($$v) {
        _vm.systemBlock = $$v
      },
      expression: "systemBlock"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "HarmonyOS",
      "value": "2"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "Android",
      "value": "0"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "iOS",
      "value": "1"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "item-title"
  }, [_vm._v("\n    版本号屏蔽 "), _c('span', {
    staticClass: "optional-tip"
  }, [_vm._v("（选填）")])]), _vm._v(" "), _c('el-form', {
    attrs: {
      "inline": true
    }
  }, _vm._l((_vm.versionBlock), function(item, index) {
    return _c('div', {
      key: 'ver-' + index,
      staticClass: "margin-bottom-10"
    }, [_c('el-form-item', {
      attrs: {
        "label": "手机系统"
      }
    }, [_c('el-select', {
      model: {
        value: (item.osType),
        callback: function($$v) {
          _vm.$set(item, "osType", $$v)
        },
        expression: "item.osType"
      }
    }, [_c('el-option', {
      attrs: {
        "label": "HarmonyOS",
        "value": "2"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": "Android",
        "value": "0"
      }
    }), _vm._v(" "), _c('el-option', {
      attrs: {
        "label": "iOS",
        "value": "1"
      }
    })], 1)], 1), _vm._v(" "), _c('el-form-item', {
      attrs: {
        "label": "版本号"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "不限制"
      },
      model: {
        value: (item.version),
        callback: function($$v) {
          _vm.$set(item, "version", $$v)
        },
        expression: "item.version"
      }
    })], 1), _vm._v(" "), (index == 0) ? _c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": _vm.clickAddVersion
      }
    }, [_vm._v("添加")]) : _vm._e(), _vm._v(" "), (index != 0) ? _c('el-button', {
      attrs: {
        "type": "danger",
        "icon": "delete"
      },
      on: {
        "click": function($event) {
          return _vm.clickDeleteVersion(index)
        }
      }
    }) : _vm._e()], 1)
  }), 0)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3fb42540!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/OperationManage/SystemConfig/SystemConfig/Components/JuTuiAdShield.vue
// module id = 998
// module chunks = 0